import { apiFetch } from '@/shared/api/client'

export type ApiAttendanceStaff = {
  id: string
  name: string
  role: 'HEAD_KITCHEN' | 'STAFF_KITCHEN'
  role_label: string
  shift_start: string
  shift_end: string
  check_in_at?: string
  check_out_at?: string
  check_in_photo?: string
  check_out_photo?: string
  on_time?: boolean
}

export type ApiTodayAttendance = {
  staff: ApiAttendanceStaff[]
}

export async function fetchTodayAttendance(deviceId: string): Promise<ApiTodayAttendance> {
  const encoded = encodeURIComponent(deviceId)
  return apiFetch<ApiTodayAttendance>(`/kitchen/attendance/today?device_id=${encoded}`)
}
